// Move CTA sticky button to body to fix positioning
document.addEventListener('DOMContentLoaded', function() {
  const visibleSummary = document.querySelector('.bundle-summary-visible');
  const stickySummary = document.querySelector('.bundle-summary-sticky');
  
  if (visibleSummary && stickySummary) {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    if (width < 900) {
      // Calculate header height dynamically
      const websiteHeader = document.querySelector('.header--has-menu');
      const stickyMenuOffset = websiteHeader ? websiteHeader.offsetHeight : 0;
      
      // Remove the sticky button from its current location
      const parentElement = stickySummary.parentElement;
      parentElement.removeChild(stickySummary);

      const stickyButton = stickySummary.querySelector('#add-bundle-to-cart-sticky');
      
      // Add it directly to the body
      document.body.appendChild(stickySummary);
      
      // Now set all the styles for sticky summary
      stickySummary.style.visibility = "hidden";
      stickySummary.style.position = 'fixed';
      stickySummary.style.top = `${stickyMenuOffset - 4}px`; // Use dynamic height
      stickySummary.style.left = '0';
      stickySummary.style.right = '0';
      stickySummary.style.width = '100%';
      stickySummary.style.height = 'auto';
      stickySummary.style.margin = '0';
      stickySummary.style.padding = '15px 20px';
      stickySummary.style.borderRadius = '0';
      stickySummary.style.zIndex = '10000';
      stickySummary.style.backgroundColor = '#f8f9fa';
      stickySummary.style.borderBottom = '1px solid #e0e0e0';
      stickySummary.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
      stickySummary.style.display = 'block';
      stickySummary.style.boxSizing = 'border-box';
      stickySummary.style.transform = 'none';
      stickySummary.style.transition = 'all 0.15s ease';
      
      // Typography and content styles
      stickySummary.style.fontSize = '14px';
      stickySummary.style.lineHeight = '1.4';
      stickySummary.style.color = '#333';
      
      // Ensure content is properly laid out
      //stickySummary.style.overflow = 'hidden';
      //stickySummary.style.textOverflow = 'ellipsis';
      //stickySummary.style.whiteSpace = 'nowrap';

      // Style the button inside sticky summary
      if (stickyButton) {
        stickyButton.style.minHeight = 'calc(3rem + var(--buttons-border-width) * 2)';
        stickyButton.style.fontSize = '1.2rem';
      }
      
      // Set up intersection observer
      const observer = new IntersectionObserver(
      function(entries) {
        const entry = entries[0];
        const rect = entry.boundingClientRect;
        const isVisible = entry.isIntersecting;
        
        // Check if visible summary has been scrolled past (completely above viewport)
        const hasScrolledPast = rect.bottom < 0;
        
        if (hasScrolledPast) {
          // User has scrolled past the visible summary - show sticky
          stickySummary.style.visibility = "visible";
          stickySummary.style.opacity = "1";
          stickySummary.style.transform = "translateY(0)";
          stickySummary.style.transition = 'all 0.15s ease';
        } else {
          // Visible summary is in view OR user hasn't reached it yet - hide sticky
          stickySummary.style.visibility = "hidden";
          stickySummary.style.opacity = "0";
          stickySummary.style.transform = "translateY(-100%)";
          stickySummary.style.transition = 'all 0.1s ease';
        }
      },
      { 
        threshold: [0, 1], // Trigger when element enters/exits viewport
        rootMargin: '0px 0px 0px 0px'
      }
    );
      
      // Start observing the visible button
      observer.observe(visibleSummary);

      // Add event listener to sticky button (after creating the sticky summary)
      const stickyAddToCartBtn = stickySummary.querySelector('#add-bundle-to-cart-sticky');
      if (stickyAddToCartBtn) {
        stickyAddToCartBtn.addEventListener('click', function(event) {
        // Find the visible button and trigger its click event
        const visibleBtn = document.getElementById('add-bundle-to-cart');
        if (visibleBtn) {
          visibleBtn.click();
        }
      });
      }

      // Hide sticky bar when mobile menu is open
      const menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
if (menuDrawerDetails) {
  const otherStickyMenu = document.querySelector('.sticky_menu');
  
  const menuObserver = new MutationObserver(() => {
    if (menuDrawerDetails.hasAttribute('open')) {
      stickySummary.style.zIndex = '1';
      if (otherStickyMenu) otherStickyMenu.style.zIndex = '0';
    } else {
      stickySummary.style.zIndex = '10000';
      if (otherStickyMenu) otherStickyMenu.style.zIndex = '0'; // keep it low during close animation
      setTimeout(() => {
        if (otherStickyMenu) otherStickyMenu.style.zIndex = '2'; // restore after animation done
      }, 400);
    }
  });
  menuObserver.observe(menuDrawerDetails, { attributes: true, attributeFilter: ['open'] });
}
      
    } else {
      // Desktop: Hide the sticky button completely
      stickySummary.style.display = 'none';
    }
  } else {
    console.error("Could not find bundle-summary-visible or bundle-summary-sticky elements");
  }
  document.dispatchEvent(new CustomEvent('hc:cards-ready'));
});